"use client";

import { useCallback } from "react";
import { useSendVisitorMessageMutation } from "@/lib/graphql/queries/generated/messaging.generated";
import { useWidgetEnv } from "@/lib/use-widget-env";
import { captureVisitorPage } from "./capture-visitor-page";
import { sendWithPage } from "./send-with-page";

/**
 * `useSendVisitorMessageMutation` that attaches the host `page` to EVERY send (captured when `send`
 * is called) and falls back for an older BE. Drop-in: same `[send, result]` tuple.
 */
export function useSendVisitorMessage() {
  const kind = useWidgetEnv().kind;
  const [send, result] = useSendVisitorMessageMutation();
  const sendPaged = useCallback(
    (options: Parameters<typeof send>[0]) =>
      sendWithPage({ send, options, page: captureVisitorPage(kind) }),
    [send, kind],
  );
  return [sendPaged, result] as const;
}
